import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TrackingFacadeService } from 'src/app/services/tracking/tracking-facade.service';


@Component({
  selector: 'app-error-message',
  templateUrl: './error-message.component.html',
  styleUrls: ['./error-message.component.scss']
})
export class ErrorMessageComponent implements OnInit {

  @Input('title')
  public title = 'noget gik galt...'
  @Input('description')
  public description = 'Betalingen kunne ikke gennemføres. Forsøg igen eller vælg en anden betalingsmetode'
  @Input('url')
  public url: string | null;
  @Input('button-text')
  public buttonText = 'forsøg igen'

  constructor(private router: Router, private trackingFacadeService: TrackingFacadeService) { }

  ngOnInit(): void {
    // Tracked centrally for every app-error-message: this component is only rendered when an error is shown.
    this.trackingFacadeService.trackError(this.title, this.description, this.url ?? undefined);
  }

  onClickHandler(): void {
    if (this.url === '/') {
      // The frontpage is a Sitecore page outside the Angular SPA, so it is
      // not a registered router route. Use a full browser navigation instead.
      window.location.href = '/';
    } else if (this.url) {
      this.router.navigateByUrl(this.url);
    } else {
      location.reload();
    }
  }

}
